<template>
  <div class="payload-generic other">
    <table>
      <tr>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <div class="message">
            <carousel
              ref="carousel"
              :per-page="1"
              :mouse-drag="true"
              :paginationEnabled="false"
              :navigationEnabled="true"
            >
              <slide
                v-for="(payload, index) in conversation.message.payloads"
                :key="index"
              >
                <div class="card">
                  <div v-if="payload.image_url" class="img-title">
                    <img :src="payload.image_url" alt="Image" />
                  </div>
                  <div class="generic-body">
                    <div class="title">
                      {{ payload.title }}
                    </div>
                    <div class="subtitle">
                      {{ payload.subtitle }}
                    </div>
                    <div
                      v-for="(button, key) in payload.buttons"
                      v-bind:key="key"
                      class="element"
                      v-on:click="handleButton(button)"
                    >
                      {{ button.title }}
                    </div>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'PayloadGeneric',
  components: {
    Carousel,
    Slide
  },
  props: {
    conversation: Object
  },
  mounted() {
    setTimeout(() => {
      this.$refs.carousel.onResize()
      this.$refs.carousel.goToPage(0)
    }, 100)
  },
  methods: {
    handleButton(button) {
      return this.$parent.handleButton(button)
    }
  }
}
</script>
